'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Growl = exports.Outer = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactPose = require('react-pose');

var _reactPose2 = _interopRequireDefault(_reactPose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Outer = exports.Outer = _styledComponents2.default.div.attrs(function () {
  return {
    className: 'crystallize-growl',
    role: 'alert',
    'aria-live': 'assertive'
  };
}).withConfig({
  displayName: 'styles__Outer',
  componentId: 's1i9qfvi-0'
})(['position:fixed;z-index:999;top:15px;right:15px;display:flex;flex-direction:column;align-items:flex-end;width:0;']);

function getItemClassNames(_ref) {
  var type = _ref.type;

  var classes = ['__item'];
  if (type) {
    classes.push('__item--' + type);
  }
  return classes.map(function (c) {
    return 'crystallize-growl' + c;
  }).join(' ');
}

function getTheme(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case 'error':
      return '\n        background: orangered;\n        color: #fff;\n      ';
    case 'warning':
      return '\n        background: #f58ea5;\n        box-shadow: 0 0 5px hsl(347, 84%, 26%);\n      ';
    case 'success':
      return '\n        background: #75c575;\n        color: #fff;\n        box-shadow: 0 0 5px #75c575;\n      ';
    default:
      return '\n        background: #fff;\n      ';
  }
}

var GrowlPosed = _reactPose2.default.div({
  enter: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.5 }
});

var Growl = exports.Growl = (0, _styledComponents2.default)(GrowlPosed).attrs(function () {
  return {
    className: getItemClassNames
  };
}).withConfig({
  displayName: 'styles__Growl',
  componentId: 's1i9qfvi-1'
})(['box-shadow:0 0 5px rgba(0,0,0,0.25);padding:10px 20px;cursor:default;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;box-sizing:border-box;transition:color 100ms,background-color 100ms;border-radius:20px;transform-origin:center center;min-width:100px;max-width:400vw;', ';&:not(:first-child){margin-top:5px;}::selection{background:transparent;}'], getTheme);